// extracted by mini-css-extract-plugin
export default {"wrapper":"a3-z","play":"b3-z"};